import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, ButtonGroup, Button } from 'reactstrap';
import { US, SI } from 'country-flag-icons/react/3x2';
import ToggleFullscreen from '../Common/ToggleFullscreen';
import HeaderRun from './Header.run';
import swal from 'sweetalert';
import { useTranslation } from 'react-i18next';
import * as userService from '../Application/Services/userService';
import moment from 'moment/min/moment-with-locales';
import { getMineOrSelected } from '../Application/Services/utils';
import useSettingsStore from '../../stores/settingsStore';

const Header = () => {
  const { t, i18n } = useTranslation();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [language, setLanguage] = useState('en');
  const [MineOrAllSelected, setMineOrAllSelected] = useState('0');

  // Zustand settings store
  const settings = useSettingsStore((state) => state.settings);
  const changeSetting = useSettingsStore((state) => state.changeSetting);
  const toggleSetting = useSettingsStore((state) => state.toggleSetting);

  useEffect(() => {
    HeaderRun();
    let mineOrAll = getMineOrSelected();
    setMineOrAllSelected(mineOrAll);

    // Set language from settings if available
    if (settings && settings.language) {
      updateLanguage(settings.language);
      setLanguage(settings.language);

      if (settings.language === 'si') {
        moment.locale('sl');
      } else {
        moment.locale(settings.language);
      }
    } else {
      moment.locale('en');
    }
    // eslint-disable-next-line
  }, [settings.language]);

  const changeLanguage = (lng) => {
    updateLanguageButton(lng);
    let updateValue = [{ id: 0, value: lng, name: 'language' }];
    userService.updateUserSettings(updateValue).then(() => {
      changeSetting('language', lng);
      i18n.changeLanguage(lng);

      if (lng === 'si') {
        moment.locale('sl');
      } else {
        moment.locale(lng);
      }
    });
  };

  const updateLanguage = (lng) => {
    updateLanguageButton(lng);
    i18n.changeLanguage(lng);
  };

  const updateLanguageButton = (lng) => {
    setLanguage(lng);
  };

  const getLanguage = () => {
    if (language === 'en') {
      return <US title={t('common.ENGLISH')} />;
    } else if (language === 'si') {
      return <SI title={t('common.SLOVENE')} />;
    } else if (language === 'de') {
      return t('common.GERMAN');
    } else if (language === 'es') {
      return t('common.SPANISH');
    }
  };

  const toggleLanguage = () => {
    setDropdownOpen((prev) => !prev);
  };

  const toggleOffsidebar = (e) => {
    e.preventDefault();
    toggleSetting('offsidebarOpen');
  };

  const toggleCollapsed = (e) => {
    e.preventDefault();
    toggleSetting('isCollapsed');
    resize();
  };

  const toggleAside = (e) => {
    e.preventDefault();
    toggleSetting('asideToggled');
  };

  const resize = () => {
    window.dispatchEvent(new Event('resize'));
  };

  const logout = (e) => {
    e.preventDefault();
    swal({
      title: t('login.LOG_OUT'),
      text: t('login.LOG_OUT_TEXT'),
      icon: 'warning',
      buttons: {
        cancel: {
          text: t('common.CANCEL'),
          visible: true,
          closeModal: true,
        },
        confirm: {
          text: t('login.LOG_OUT'),
          value: true,
          visible: true,
          closeModal: true,
        },
      },
      dangerMode: true,
    }).then(async (willLogout) => {
      if (willLogout) {
        window.location.href = '/login';
        // You should also call your authStore's logout here if you have one
        // await useAuthStore.getState().logout();
      }
    });
  };

  const onSelectAllOrMine = async (selected) => {
    setMineOrAllSelected(selected);
    // If you want to update statistics or global state, do it here
    // const { data: statisticsData } = await statistics.getStatistics(selected);
    // setGlobal({ MineOrAllSelected: selected, statistic: statisticsData });
  };

  return (
    <header className="topnavbar-wrapper">
      {/* START Top Navbar */}
      <nav className="navbar topnavbar">
        {/* START navbar header */}
        <div className="navbar-header">
          <a className="navbar-brand" href="#/">
            <div className="brand-logo">
              <img className="img-fluid" src="img/logo.png" alt="App Logo" />
            </div>
            <div className="brand-logo-collapsed">
              <img className="img-fluid" src="img/logo-single.png" alt="App Logo" />
            </div>
          </a>
        </div>
        {/* END navbar header */}

        {/* START Left navbar */}
        <ul className="navbar-nav mr-auto flex-row">
          <li className="nav-item">
            {/* Button used to collapse the left sidebar. Only visible on tablet and desktops */}
            <Link
              to=""
              title={t('common.SHOW_HIDE_MENU')}
              className="nav-link d-none d-md-block d-lg-block d-xl-block"
              onClick={toggleCollapsed}
            >
              <em className="fas fa-bars"></em>
            </Link>
            {/* Button to show/hide the sidebar on mobile. Visible on mobile only. */}
            <a href="" className="nav-link sidebar-toggle d-md-none" onClick={toggleAside}>
              <em className="fas fa-bars"></em>
            </a>
          </li>
          <li className="nav-item">
            <Link
              to=""
              title={t('login.LOG_OUT')}
              className="nav-link d-none d-md-block d-lg-block d-xl-block"
              onClick={logout}
            >
              <em className="icon-logout"></em>
            </Link>
          </li>
        </ul>
        {/* END Left navbar */}
        {/* START Right Navbar */}
        <ul className="navbar-nav flex-row">
          {/* Fullscreen (only desktops) */}
          {/* <li style={{ marginTop: 12, marginRight: 12 }}>
            <ButtonGroup>
              <Button onClick={() => onSelectAllOrMine('0')} active={MineOrAllSelected === '0'}>
                <b>{t('common.MINE')}</b>
              </Button>
              <Button onClick={() => onSelectAllOrMine('1')} active={MineOrAllSelected === '1'}>
                <b>{t('common.ALL')}</b>
              </Button>
            </ButtonGroup>
          </li> */}
          <li style={{ marginTop: 12, marginBottom: 0 }}>
            <Dropdown isOpen={dropdownOpen} toggle={toggleLanguage}>
              <DropdownToggle className="p-1">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  {language === 'en' ? (
                    <>
                      <US width="24" height="24" title={t('common.ENGLISH')} />
                      <span className="pl-1 font-weight-bold">{t('common.ENGLISH')}</span>
                    </>
                  ) : (
                    <>
                      <SI width="24" height="24" title={t('common.SLOVENE')} />
                      <span className="pl-1 font-weight-bold">{t('common.SLOVENE')}</span>
                    </>
                  )}
                </div>
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-right-forced animated fadeInUpShort">
                <DropdownItem onClick={() => changeLanguage('en')}>
                  <US width="24" height="24" title={t('common.ENGLISH')} />
                  <span className="pl-1 font-weight-bold">{t('common.ENGLISH')}</span>
                </DropdownItem>
                <DropdownItem onClick={() => changeLanguage('si')}>
                  <SI width="24" height="24" title={t('common.SLOVENE')} />
                  <span className="pl-1 font-weight-bold">{t('common.SLOVENE')}</span>
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </li>
          <li className="nav-item d-none d-md-block">
            <ToggleFullscreen className="nav-link" title={t('login.FULL_SCREEN')} />
          </li>
          <li className="nav-item">
            <a className="nav-link" href="" onClick={toggleOffsidebar} title={t('login.VISUAL_OPTIONS')}>
              <em className="icon-notebook"></em>
            </a>
          </li>
          {/* END Offsidebar menu */}
        </ul>
        {/* END Right Navbar */}
      </nav>
      {/* END Top Navbar */}
    </header>
  );
};

export default Header;
